import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import ProgressBar from 'react-bootstrap/ProgressBar';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../../../App.css';
import '../../../css/bootstrap.scss';
import questionnaire_icon from "../../../images/Questionnaire_icon.png";
import { reduxForm, InjectedFormProps } from 'redux-form';
import { setwizardPageNumber, setQuestionnaireScreen2 } from '../../authslice';
import { RootState } from "../../store";
import { connect, useDispatch, useSelector } from "react-redux";
import { updatePersonalKycDraftStep } from "Utils/personalKycDraft";
import Header from "../../Includes/Header";
import BackButton from "../../Includes/BackButton";
import { ToastBox } from "MyComponents/Toaster";
import CheckboxGroup from "MyComponents/UI/CheckBoxGroup";

interface Props { }

const checkboxLabels = [
    { id: 'checkbox1', label: 'Salary' },
    { id: 'checkbox2', label: 'Investment' },
    { id: 'checkbox3', label: 'Savings' },
    { id: 'checkbox4', label: 'Inheritance' },
    { id: 'checkbox5', label: 'Credit/Loan' },
    { id: 'checkbox6', label: 'Family or others' },
    { id: 'checkbox7', label: 'Digital asset income' },
    { id: 'checkbox8', label: 'Pension' },
    { id: 'checkbox9', label: 'Donation' },
    { id: 'checkbox10', label: 'Real estate income' },
    { id: 'checkbox11', label: 'Other' },
];

interface CheckboxState {
    [key: string]: boolean;
}

const Questionnaire_Screen2: React.FC<Props & InjectedFormProps<{}, Props, FormData>> = (props: any) => {
    const { t } = useTranslation();
    const { handleSubmit } = props;
    const dispatch = useDispatch();
    const page = useSelector((state: RootState) => state.auth.wizardPageNumber);
    const questionnaireScreen2 = useSelector((state: RootState) => state.auth.questionnaireScreen2);
    const userID = useSelector((state: RootState) => state.auth.userID);

    const [validated, setValidated] = useState(false);
    const [checkboxes, setCheckboxes] = useState<CheckboxState>({});

    useEffect(() => {
        const initialCheckboxState: CheckboxState = {};
        checkboxLabels.forEach(({ id }) => { initialCheckboxState[id] = false; });
        questionnaireScreen2.forEach((value: string) => {
            const matchingCheckbox = checkboxLabels.find((item) => item.label === value);
            if (matchingCheckbox) initialCheckboxState[matchingCheckbox.id] = true;
        });
        setCheckboxes(initialCheckboxState);
    }, [questionnaireScreen2]);

    const isAtLeastOneCheckboxChecked = Object.values(checkboxes).some((isChecked) => isChecked);

    const submitForm = () => {
        if (!isAtLeastOneCheckboxChecked) {
            setValidated(true);
        } else {
            const checkedCheckboxes = Object.entries(checkboxes)
                .filter(([_, value]) => value)
                .map(([key]) => checkboxLabels.find(item => item.id === key)?.label);
            dispatch(setQuestionnaireScreen2(checkedCheckboxes as string[]));
            dispatch(setwizardPageNumber(page + 1));
            localStorage.setItem('pageNumber', `${page + 1}`);
            if (userID) {
                updatePersonalKycDraftStep(userID, 'questionnaire', { screen2: checkedCheckboxes });
                updatePersonalKycDraftStep(userID, 'wizardState', { pageNumber: page + 1 });
            }
        }
    };

    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { id, checked } = e.target;
        setValidated(false);
        setCheckboxes((prevCheckboxes) => ({ ...prevCheckboxes, [id]: checked }));
    };

    return (
        <>
            <ToastBox />
            <Container fluid className="px-0 px-md-3">
                <Row className="g-0">
                    <Col md={12} className="mx-auto px-2 pt-0 pb-3">
                        <div className="mt-5">
                            <Row className="px-2 px-md-5">
                                <Col md={12}><BackButton /></Col>
                            </Row>
                            <Row className="px-2 px-md-5">
                                <Col md={12}>
                                    <div className="d-flex align-items-start py-3">
                                        <img src={questionnaire_icon} width={48} className="d-none d-md-block me-3 mt-1" alt="Questionnaire Icon" />
                                        <div>
                                            <h3 className="text-start m-0">{t('kyc.questionnaire')}</h3>
                                            <p className="fw-normal text-secondary m-0 mt-1 text-nowrap">{t('kyc.individual_form')}</p>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="px-2 px-md-5">
                                <Col md={12}>
                                    <div className="d-none d-md-flex align-items-center">
                                        <ProgressBar variant="primary" className="custom_progressbar mr-2" now={20} />
                                        <p className="fw-bold small py-3 px-3 m-0">2/7</p>
                                    </div>
                                    <p className="fw-bold text-start mt-4 m-0">{t('kyc.q2_title')}</p>
                                    <p className="text-secondary text-start small mt-1">{t('kyc.q2_desc')}</p>
                                    {validated && (
                                        <p className="text-danger text-start small fw-bold">{t('common.please_check_one')}</p>
                                    )}
                                    <Form noValidate onSubmit={handleSubmit(submitForm)}>
                                        <Row className="mt-4 text-start align-items-center">
                                            <CheckboxGroup
                                                checkboxes={checkboxLabels.map((checkbox) => ({
                                                    ...checkbox,
                                                    checked: checkboxes[checkbox.id],
                                                }))}
                                                onCheckboxChange={handleCheckboxChange}
                                            />
                                        </Row>
                                        <Row className="mt-4 text-start">
                                            <Col md={8}>
                                                <Button type="submit" className="btn btn-primary rounded-5" style={{ width: "220px" }}>
                                                    {t('common.next')}
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Form>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

const form = reduxForm<{}, Props, FormData>({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    form: 'wizard',
    enableReinitialize: true,
})(Questionnaire_Screen2);

export default connect(null)(form);
